export { default as ConnectFragmentsDumb } from './connect-fragments-dumb';
